"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _humps = require("humps");

var errorCodes = {
  FIELD_IS_REQUIRED: 'FIELD_IS_REQUIRED',
  FIELD_IS_INVALID: 'FIELD_IS_INVALID',
  CONFLICT: 'CONFLICT'
};

var RequestErrorItem = /*#__PURE__*/function () {
  function RequestErrorItem(apiFieldError) {
    (0, _classCallCheck2.default)(this, RequestErrorItem);
    (0, _defineProperty2.default)(this, "type", 'RequestErrorItem');
    (0, _defineProperty2.default)(this, "field", void 0);
    (0, _defineProperty2.default)(this, "message", void 0);
    (0, _defineProperty2.default)(this, "code", void 0);
    this.field = apiFieldError.source && apiFieldError.source.parameter ? (0, _humps.camelize)(apiFieldError.source.parameter) : null;
    this.message = apiFieldError.detail;
    this.code = apiFieldError.code || null;
  }

  (0, _createClass2.default)(RequestErrorItem, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      return this.code === errorCodes.FIELD_IS_REQUIRED;
    }
  }, {
    key: "isInvalid",
    value: function isInvalid() {
      return this.code === errorCodes.FIELD_IS_INVALID;
    }
  }, {
    key: "isConflicted",
    value: function isConflicted() {
      return this.code === errorCodes.CONFLICT;
    }
  }]);
  return RequestErrorItem;
}();

var _default = RequestErrorItem;
exports.default = _default;
//# sourceMappingURL=request-error-item.js.map